export const siteInfo = {
  name: '91黑料',
  tagline: '海量黑料短视频 · 每日更新看不停',
  slogan: '最新最全的黑料视频合集，让你看过瘾',
  intro: '91黑料是国内领先的黑料短视频聚合平台，专注搜集全网最新最热的黑料视频内容。我们每日更新海量黑料短视频，涵盖明星八卦、网红爆料、综艺内幕、社会热点等多个领域。无论你是想追最新黑料还是回顾经典合集，91黑料视频专区都能满足你。黑料视频在线观看，随时随地，想看就看。',
  stat1: '每日更新 200+ 条黑料视频',
  stat2: '覆盖 30+ 内容品类',
  stat3: '千万用户共同选择',
};

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '黑料视频', href: '#media' },
  { label: '专题合集', href: '#index' },
  { label: '焦点专题', href: '#carousel' },
  { label: '最新快讯', href: '#updates' },
  { label: '联系我们', href: '#contact' },
];

export const mediaItems = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店同框画面曝光',
    cover: 'https://readdy.ai/api/search-image?query=Dimly%20lit%20luxury%20hotel%20lobby%20at%20night%20with%20two%20silhouetted%20figures%20walking%20through%20glass%20doors%2C%20paparazzi%20style%20lighting%2C%20dramatic%20warm%20tones%2C%20cinematic%20composition%2C%20blurred%20background%20with%20chandeliers%2C%20mysterious%20atmosphere&width=640&height=360&seq=media-01&orientation=landscape',
    category: '明星八卦',
    views: '128.6万',
    time: '2小时前',
    duration: '03:25',
    hot: true,
  },
  {
    id: 2,
    title: '当红女星片场耍大牌实锤？工作人员爆料内幕细节',
    cover: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20professional%20camera%20equipment%20and%20lighting%20rigs%2C%20crew%20members%20standing%20in%20background%2C%20dramatic%20lighting%20contrast%2C%20warm%20golden%20hour%20tones%2C%20cinematic%20depth%20of%20field%2C%20tension%20in%20the%20air&width=640&height=360&seq=media-02&orientation=landscape',
    category: '娱乐内幕',
    views: '96.3万',
    time: '5小时前',
    duration: '05:18',
    hot: true,
  },
  {
    id: 3,
    title: '知名网红直播间翻车，意外暴露真实颜值引热议',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20studio%20setup%20with%20ring%20light%20and%20microphone%2C%20warm%20ambient%20glow%2C%20professional%20streamer%20desk%20with%20monitors%2C%20dramatic%20lighting%20with%20soft%20shadows%2C%20tech%20gadget%20filled%20room&width=640&height=360&seq=media-03&orientation=landscape',
    category: '网红爆料',
    views: '215.8万',
    time: '8小时前',
    duration: '08:42',
    hot: true,
  },
  {
    id: 4,
    title: '综艺节目暗箱操作被扒，选手淘汰背后另有隐情',
    cover: 'https://readdy.ai/api/search-image?query=Television%20talent%20show%20stage%20with%20spotlights%20and%20colorful%20LED%20screens%2C%20judges%20desk%20in%20silhouette%2C%20dramatic%20stage%20lighting%2C%20grand%20production%20set%2C%20warm%20and%20cool%20contrasting%20lights&width=640&height=360&seq=media-04&orientation=landscape',
    category: '综艺内幕',
    views: '187.4万',
    time: '12小时前',
    duration: '06:55',
    hot: false,
  },
  {
    id: 5,
    title: '大佬饭局录音流出，行业潜规则对话令人震惊',
    cover: 'https://readdy.ai/api/search-image?query=Upscale%20private%20dining%20room%20with%20round%20table%20and%20chandelier%2C%20dim%20warm%20lighting%2C%20luxury%20interior%20with%20wine%20glasses%2C%20mysterious%20and%20secretive%20atmosphere%2C%20business%20meeting%20vibe%20with%20rich%20textures&width=640&height=360&seq=media-05&orientation=landscape',
    category: '行业黑幕',
    views: '302.1万',
    time: '1天前',
    duration: '11:20',
    hot: true,
  },
];

export const updatesItems = [
  { id: 1, date: '07-29', time: '14:30', content: '某知名导演新片选角内定名单遭曝光，多位流量明星牵扯其中', tag: '独家' },
  { id: 2, date: '07-29', time: '11:15', content: '网红带货直播间被举报虚假宣传，平台已介入调查处理', tag: '热点' },
  { id: 3, date: '07-29', time: '09:42', content: '某综艺节目录制现场发生冲突，嘉宾当场罢录离场', tag: '突发' },
  { id: 4, date: '07-28', time: '22:08', content: '娱乐圈知名经纪人涉嫌偷税漏税被约谈，旗下艺人纷纷解约', tag: '重磅' },
  { id: 5, date: '07-28', time: '18:30', content: '某品牌代言人私下吐槽产品被偷拍，品牌方紧急公关', tag: '爆料' },
  { id: 6, date: '07-28', time: '15:55', content: '热门短视频平台算法推荐机制内部文件流出，引发创作者不满', tag: '内幕' },
  { id: 7, date: '07-27', time: '20:20', content: '某顶流组合成员之间不和实锤，团队聚餐全程零交流', tag: '八卦' },
  { id: 8, date: '07-27', time: '16:45', content: '直播平台头部公会刷量造假产业链曝光，涉及金额超千万', tag: '深度' },
];

export const aboutInfo = {
  title: '关于91黑料',
  content: '91黑料成立于2020年，是国内领先的黑料短视频聚合与分享平台。我们致力于为网友提供最新、最全、最劲爆的黑料视频内容。平台汇聚了来自全网的海量黑料短视频资源，涵盖明星八卦、网红爆料、综艺内幕、社会热点、行业黑幕等多个垂直领域。每日由专业编辑团队精选更新，确保内容的新鲜度和独家性。91黑料视频专区始终坚持内容为王，让每一位用户都能在这里找到想看的内容，看过瘾、看过瘾。',
  highlights: ['海量黑料视频每日更新', '多品类内容全覆盖', '专业团队甄选推荐', '千万用户信赖之选'],
};

export const rankingItems = [
  { rank: 1, title: '某女星与前经纪人闹翻全过程录音曝光，双方各执一词', heat: '🔥 502.3万', tag: 'HOT' },
  { rank: 2, title: '知名企业家私人派对画面流出，多位明星素颜出席', heat: '🔥 478.9万', tag: 'HOT' },
  { rank: 3, title: '选秀节目投票数据造假，技术员曝光后台真实票数', heat: '🔥 421.6万', tag: 'HOT' },
  { rank: 4, title: '网红情侣分手互撕聊天记录被曝光，内容劲爆', heat: '📈 356.2万', tag: 'NEW' },
  { rank: 5, title: '某综艺嘉宾私下吐槽节目组的录音意外流出', heat: '📈 298.7万', tag: 'NEW' },
  { rank: 6, title: '直播圈大佬涉嫌洗钱被调查，多名主播牵连其中', heat: '📈 275.4万', tag: 'NEW' },
  { rank: 7, title: '热门古装剧剧组内部矛盾激化，男女主片场零交流', heat: '📊 241.8万', tag: '' },
];

export const carouselItems = [
  {
    id: 1,
    title: '娱乐圈潜规则大揭秘',
    subtitle: '深度调查：那些不为人知的行业内幕',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20backstage%20of%20a%20grand%20theater%20with%20velvet%20curtains%2C%20dramatic%20single%20spotlight%2C%20mysterious%20atmosphere%2C%20empty%20seats%20in%20shadow%2C%20theatrical%20set%20design%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20cinematic%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '深度专题',
    desc: '从选角到资源分配，揭秘娱乐圈底层运作规则',
  },
  {
    id: 2,
    title: '2026上半年黑料大事记',
    subtitle: '回顾那些刷爆热搜的劲爆瞬间',
    cover: 'https://readdy.ai/api/search-image?query=Collage%20of%20newspaper%20headlines%20and%20social%20media%20feeds%20on%20a%20dark%20background%2C%20dramatic%20red%20and%20gold%20accents%2C%20newsroom%20aesthetic%2C%20breaking%20news%20vibe%2C%20multiple%20overlapping%20images%2C%20cinematic%20lighting&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '年度盘点',
    desc: '半年内最火爆的黑料视频一次看过瘾',
  },
  {
    id: 3,
    title: '短视频平台算法揭秘',
    subtitle: '你的每一次刷新都被精准计算',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20data%20center%20with%20glowing%20server%20racks%20in%20warm%20amber%20lighting%2C%20digital%20data%20streams%2C%20abstract%20network%20visualization%2C%20dark%20environment%20with%20neon%20accents%2C%20technological%20and%20mysterious%20atmosphere&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '技术揭秘',
    desc: '拆解短视频推荐算法背后的流量密码',
  },
  {
    id: 4,
    title: '网红产业链全解析',
    subtitle: '从素人到顶流的幕后推手与商业逻辑',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20social%20media%20influencer%20workspace%20with%20multiple%20screens%20showing%20charts%20and%20content%2C%20warm%20professional%20lighting%2C%20creative%20agency%20office%2C%20trendy%20industrial%20interior%2C%20content%20creation%20setup%20with%20cameras&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '行业观察',
    desc: '揭秘MCN机构的造星工厂运作模式',
  },
];

export const appInfo = {
  title: '随时随地 想看就看',
  subtitle: '91黑料移动端，黑料视频刷不停',
  desc: '支持iOS和Android双平台，更流畅的播放体验，更及时的更新推送。下载91黑料APP，海量黑料短视频装进口袋，通勤路上、睡前时光，精彩不错过。',
  features: ['高清流畅播放', '个性化推荐', '离线缓存观看', '更新实时推送'],
};

export const commentItems = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20person%2C%20neutral%20expression%2C%20studio%20portrait%20with%20soft%20warm%20lighting%2C%20simple%20cream%20background%2C%20casual%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜一线群众',
    time: '2小时前',
    content: '这个网站太顶了！每天都要来刷一遍，黑料更新的速度比微博还快，而且很多内容在其他平台根本看不到。',
    likes: 3268,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20female%2C%20warm%20smile%2C%20studio%20portrait%20with%20soft%20lighting%2C%20simple%20warm%20toned%20background%2C%20modern%20casual%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '八卦小能手',
    time: '5小时前',
    content: '关注91黑料快一年了，确实是全网黑料最全的地方。那个网红翻车的视频我看了三遍，笑死我了哈哈哈！',
    likes: 2156,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20male%2C%20confident%20expression%2C%20studio%20portrait%20with%20dramatic%20warm%20lighting%2C%20dark%20background%2C%20fashionable%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '深夜吃瓜人',
    time: '8小时前',
    content: '每天晚上睡前必刷的网站，黑料视频合集做得太好了，按时间线整理得很清楚，追起料来一点都不费劲。',
    likes: 1892,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20female%2C%20friendly%20expression%2C%20studio%20portrait%20with%20natural%20warm%20lighting%2C%20cream%20background%2C%20casual%20elegant%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '老司机带带我',
    time: '12小时前',
    content: '推荐给好几个朋友了，都说好！黑料视频在线就能看，不用下载乱七八糟的APP，这点太方便了。',
    likes: 1534,
  },
  {
    id: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20person%2C%20playful%20expression%2C%20studio%20portrait%20with%20warm%20golden%20lighting%2C%20minimalist%20background%2C%20trendy%20style&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '爆米花已备好',
    time: '1天前',
    content: '91黑料视频最新最全真不是吹的，每次有大瓜都是这里第一时间更新，已经离不开这个网站了！',
    likes: 987,
  },
];

export const topicItems = [
  { id: 1, name: '明星塌房', count: '12.6万', color: 'bg-primary-100 text-primary-700' },
  { id: 2, name: '网红翻车', count: '9.8万', color: 'bg-accent-100 text-accent-800' },
  { id: 3, name: '综艺内幕', count: '8.3万', color: 'bg-secondary-100 text-secondary-800' },
  { id: 4, name: '录音曝光', count: '7.5万', color: 'bg-primary-100/70 text-primary-700' },
  { id: 5, name: '饭圈互撕', count: '6.9万', color: 'bg-accent-100/80 text-accent-800' },
  { id: 6, name: '选秀黑幕', count: '6.2万', color: 'bg-secondary-100/80 text-secondary-800' },
  { id: 7, name: '直播圈瓜', count: '5.7万', color: 'bg-primary-100/60 text-primary-700' },
  { id: 8, name: '品牌代言', count: '5.1万', color: 'bg-accent-100/60 text-accent-800' },
  { id: 9, name: '剧组风波', count: '4.6万', color: 'bg-secondary-100/60 text-secondary-800' },
  { id: 10, name: '合同纠纷', count: '4.2万', color: 'bg-primary-100/50 text-primary-700' },
  { id: 11, name: '私生饭爆料', count: '3.8万', color: 'bg-accent-100/50 text-accent-800' },
];

export const indexItems = [
  {
    id: 1,
    title: '明星八卦专区',
    desc: '最新明星黑料视频合集，八卦不停歇',
    icon: 'ri-star-line',
    count: '2,368条',
    bgClass: 'bg-primary-100',
    iconClass: 'text-primary-600',
  },
  {
    id: 2,
    title: '网红爆料合集',
    desc: '网红圈内幕与翻车现场全纪录',
    icon: 'ri-live-line',
    count: '1,856条',
    bgClass: 'bg-accent-100',
    iconClass: 'text-accent-700',
  },
  {
    id: 3,
    title: '综艺节目揭秘',
    desc: '热门综艺幕后故事与暗箱操作',
    icon: 'ri-tv-line',
    count: '1,542条',
    bgClass: 'bg-secondary-100',
    iconClass: 'text-secondary-700',
  },
  {
    id: 4,
    title: '行业深度调查',
    desc: '娱乐圈与短视频行业潜规则揭秘',
    icon: 'ri-search-eye-line',
    count: '1,287条',
    bgClass: 'bg-primary-100/70',
    iconClass: 'text-primary-600',
  },
  {
    id: 5,
    title: '录音聊天记录',
    desc: '独家音频爆料与对话记录曝光',
    icon: 'ri-voiceprint-line',
    count: '963条',
    bgClass: 'bg-accent-100/70',
    iconClass: 'text-accent-700',
  },
  {
    id: 6,
    title: '直播圈大事件',
    desc: '直播平台头部主播风云录',
    icon: 'ri-broadcast-line',
    count: '1,128条',
    bgClass: 'bg-secondary-100/70',
    iconClass: 'text-secondary-700',
  },
  {
    id: 7,
    title: '品牌合作内幕',
    desc: '代言背后的商业博弈与翻车事件',
    icon: 'ri-handbag-line',
    count: '845条',
    bgClass: 'bg-primary-100/50',
    iconClass: 'text-primary-600',
  },
  {
    id: 8,
    title: '每日热榜追踪',
    desc: '全网黑料热度排行实时更新',
    icon: 'ri-fire-line',
    count: '3,102条',
    bgClass: 'bg-accent-100/50',
    iconClass: 'text-accent-700',
  },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7×24小时不间断更新，重大黑料第一时间推送，让你永远快人一步了解最新动态。',
  },
  {
    id: 2,
    icon: 'ri-stack-line',
    title: '海量合集',
    desc: '收录全网最全的黑料视频合集，按人物、事件、时间线多维度整理，查找回溯超方便。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '多重验证',
    desc: '团队多源交叉验证，确保每一条黑料视频的真实性，拒绝虚假信息和恶意造谣。',
  },
  {
    id: 4,
    icon: 'ri-device-line',
    title: '多端同步',
    desc: '支持电脑、手机、平板多终端无缝切换，在家用大屏看，出门用手机刷。',
  },
  {
    id: 5,
    icon: 'ri-user-voice-line',
    title: '用户共建',
    desc: '开放用户投稿通道，你手上有猛料？欢迎来91黑料爆料，一起建设最大的黑料平台。',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '91黑料视频都是真实可靠的吗？',
    answer: '我们拥有专业的编辑审核团队，所有发布的黑料视频均经过多源交叉验证。对于无法确认的内容会标注"待核实"，坚决杜绝虚假信息和恶意造谣，确保为用户提供真实有价值的黑料内容。',
  },
  {
    id: 2,
    question: '黑料视频每天什么时候更新？',
    answer: '91黑料视频实行7×24小时滚动更新机制，重大突发事件30分钟内上线。日常内容集中在每日10:00、15:00、20:00三个时段批量更新，确保用户随时都能看到最新最热的黑料短视频。',
  },
  {
    id: 3,
    question: '如何在91黑料上找到我感兴趣的黑料视频？',
    answer: '你可以通过首页的专题索引、话题标签、热度榜单快速定位感兴趣的内容。也可以通过搜索功能按人物姓名、事件关键词进行精准查找。我们还会根据你的浏览习惯推送个性化的黑料视频推荐。',
  },
  {
    id: 4,
    question: '我也想爆料，怎么联系91黑料？',
    answer: '欢迎投稿！你可以通过页面底部的"联系我们"区域找到投稿邮箱和联系方式。我们承诺对所有爆料人信息严格保密，对于采用的内容将给予相应奖励。你的猛料，就是我们的动力！',
  },
];

export const cardItems = [
  {
    id: 1,
    title: '某影帝深夜出入高档会所，同行女伴身份成谜',
    cover: 'https://readdy.ai/api/search-image?query=Luxury%20private%20club%20entrance%20at%20night%20with%20warm%20amber%20lighting%2C%20valet%20parking%2C%20expensive%20cars%2C%20mysterious%20atmosphere%2C%20urban%20nightlife%20scene%2C%20cinematic%20photography%20with%20shallow%20depth%20of%20field&width=640&height=420&seq=card-01&orientation=landscape',
    tag: '独家爆料',
    date: '2026-07-29',
    excerpt: '记者蹲守多日拍到的独家画面，这位以好男人形象示人的影帝，究竟隐藏着什么秘密？',
  },
  {
    id: 2,
    title: '选秀节目导师内定？知情人士透露选拔全过程',
    cover: 'https://readdy.ai/api/search-image?query=Reality%20show%20audition%20room%20with%20judges%20table%20and%20stage%20area%2C%20dramatic%20spotlight%20lighting%2C%20tension%20atmosphere%2C%20production%20crew%20in%20background%2C%20warm%20theatrical%20tones&width=640&height=420&seq=card-02&orientation=landscape',
    tag: '深度调查',
    date: '2026-07-28',
    excerpt: '从海选到决赛，每一轮的晋级名单其实早有安排。真正的实力选手为何屡遭淘汰？',
  },
  {
    id: 3,
    title: '带货一哥佣金比例曝光，品牌方直呼吃不消',
    cover: 'https://readdy.ai/api/search-image?query=E-commerce%20live%20streaming%20studio%20with%20product%20display%20shelves%2C%20professional%20lighting%20setup%2C%20busy%20atmosphere%2C%20workers%20preparing%20shipments%2C%20warm%20industrial%20aesthetic%2C%20modern%20warehouse%20style&width=640&height=420&seq=card-03&orientation=landscape',
    tag: '行业内幕',
    date: '2026-07-28',
    excerpt: '某头部主播真实佣金协议被曝光，最高抽成比例令人咋舌，品牌方利润几乎被榨干。',
  },
  {
    id: 4,
    title: '热门CP假戏真做？剧组人员爆料两人私下关系',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20film%20set%20during%20golden%20hour%2C%20two%20actors%20in%20period%20costumes%20standing%20apart%2C%20warm%20sunset%20lighting%2C%20professional%20camera%20equipment%2C%20dreamy%20cinematic%20atmosphere&width=640&height=420&seq=card-04&orientation=landscape',
    tag: 'CP爆料',
    date: '2026-07-27',
    excerpt: '荧幕情侣私下真实关系大揭秘，到底是真情流露还是营销炒作？多方信息交叉印证。',
  },
  {
    id: 5,
    title: '头部MCN机构内部培训资料流出，打造网红有公式',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20creative%20office%20meeting%20room%20with%20whiteboard%20full%20of%20diagrams%2C%20young%20team%20brainstorming%2C%20trendy%20workspace%2C%20warm%20natural%20light%2C%20startup%20vibe%2C%20industrial%20interior%20design&width=640&height=420&seq=card-05&orientation=landscape',
    tag: '行业揭秘',
    date: '2026-07-27',
    excerpt: '从人设打造到话题运营，从涨粉技巧到变现路径，一份内部培训手册曝光了全部秘密。',
  },
  {
    id: 6,
    title: '娱乐圈大佬饭局文化揭秘：资源交换的潜规则',
    cover: 'https://readdy.ai/api/search-image?query=Upscale%20Chinese%20private%20dining%20room%20with%20circular%20table%2C%20traditional%20decor%2C%20dim%20warm%20lighting%2C%20luxury%20setting%2C%20wine%20and%20fine%20dining%2C%20secretive%20business%20meeting%20atmosphere&width=640&height=420&seq=card-06&orientation=landscape',
    tag: '饭局揭秘',
    date: '2026-07-26',
    excerpt: '京城高端饭局圈内人士现身说法，明星资源交换的暗箱操作远比想象中复杂。',
  },
  {
    id: 7,
    title: '某平台算法负责人离职爆料：推荐机制如何操控舆论',
    cover: 'https://readdy.ai/api/search-image?query=Dimly%20lit%20tech%20office%20with%20multiple%20computer%20monitors%20displaying%20code%20and%20data%20visualizations%2C%20late%20night%20work%20atmosphere%2C%20modern%20minimalist%20setup%2C%20warm%20screen%20glow%2C%20mysterious%20tech%20environment&width=640&height=420&seq=card-07&orientation=landscape',
    tag: '技术爆料',
    date: '2026-07-26',
    excerpt: '前算法工程师离职后首次发声，揭示热搜榜单背后的真实运作逻辑和舆论操控手段。',
  },
];

export const contactInfo = {
  title: '联系我们',
  subtitle: '你有猛料？欢迎来爆料！',
  desc: '91黑料始终欢迎用户投稿和爆料。如果你手上有独家黑料视频、录音、聊天记录或其他劲爆内容，请通过以下方式联系我们。我们承诺对爆料人信息严格保密，一经采用必有重谢。',
  email: 'tips@91heiliao.com',
  wechat: 'heiliao91',
  tips: '投稿请注明事件时间、人物和相关背景信息，视频素材请提供原始文件',
};

export const footerLinks = [
  {
    title: '关于我们',
    links: ['平台介绍', '团队信息', '发展历程', '加入我们'],
  },
  {
    title: '内容导航',
    links: ['黑料视频', '最新快讯', '热度榜单', '专题合集', '话题标签'],
  },
  {
    title: '用户服务',
    links: ['投稿爆料', '意见反馈', '内容申诉', '商务合作'],
  },
  {
    title: '法律声明',
    links: ['用户协议', '隐私政策', '版权声明', '免责条款'],
  },
];